import { useState } from "react"
import PropTypes from "prop-types"
// @mui
import { IconButton, InputAdornment, TextField, Tooltip } from "@mui/material"
//
import Iconify from "minimals-template/components/Iconify"
import noop from "lib/noop"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"

// ----------------------------------------------------------------------

CopyClipboard.propTypes = {
    value: PropTypes.string,
}
export default function CopyClipboard({ value, readOnly, ...other }) {
    const [state, setState] = useState({
        value,
    })
    const handleChange = (event) => {
        setState({ value: event.target.value })
    }

    return (
        <TextField
            fullWidth
            value={state.value}
            onChange={readOnly ? noop : handleChange}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <Tooltip title="Copy">
                                <IconButton onClick={copy} data-cy="copy-clipboard-icon">
                                    <Iconify icon={"eva:copy-fill"} width={24} height={24} />
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    ),
                },
            }}
            {...other}
        />
    )

    async function copy() {
        try {
            await navigator.clipboard.writeText(value)
            successSnackbar("Token copied to the clipboard")
        } catch (e) {
            errorSnackbar("Couldn't copy the token to the clipboard")
        }
    }
}
